export default "__VITE_ASSET__DkG0MmAw__"